import { FunctionComponent, useEffect, useRef } from "react";
import { useRouteError } from "react-router";

import { trackException } from "../../../../utils/appInsights";
import { GlobalErrorFallback } from "./GlobalErrorFallback";

export const RouteErrorBoundary: FunctionComponent = () => {
  const error = useRouteError();
  const lastReportedErrorRef = useRef<unknown>(undefined);

  useEffect(() => {
    if (lastReportedErrorRef.current === error) {
      return;
    }

    lastReportedErrorRef.current = error;
    trackException(error, "RouteErrorBoundary");
  }, [error]);

  return <GlobalErrorFallback />;
};
